import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/api/api.service';
import { ORDER_ADDITIONS_ENDPOINTS } from 'src/app/core/api/endpoints/order-additions.endpoints';

@Injectable({
  providedIn: 'root'
})
export class OrderAdditionsService {
  private api = inject(ApiService);

  updateOrderAdditions(id, data): Observable<any> {
    return this.api.put(ORDER_ADDITIONS_ENDPOINTS.V1.ADMIN_ORDER_DYNAMIC_SERVICE_ADDITIONAL_FIELDS(id), data);
  }
}
